import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import data from '../../src/UnderlineNav.docs.json';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ComponentProps = makeShortcode("ComponentProps");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`Use the UnderlineNav component to style navigation with a minimal underlined selected state, typically used for navigation placed at the top of the page.`}</p>
    <p>{`To use UnderlineNav with `}<a parentName="p" {...{
        "href": "https://github.com/ReactTraining/react-router"
      }}>{`react-router`}</a>{` or
`}<a parentName="p" {...{
        "href": "https://www.npmjs.com/package/react-router-dom"
      }}>{`react-router-dom`}</a>{`, pass
`}<inlineCode parentName="p">{`as={NavLink}`}</inlineCode>{` and omit the `}<inlineCode parentName="p">{`selected`}</inlineCode>{` prop.
This ensures that the NavLink gets `}<inlineCode parentName="p">{`activeClassName='selected'`}</inlineCode></p>
    <p><strong parentName="p">{`Attention:`}</strong>{` Make sure to properly label your `}<inlineCode parentName="p">{`UnderlineNav`}</inlineCode>{` with an `}<inlineCode parentName="p">{`aria-label`}</inlineCode>{` to provide context about the type of navigation contained in `}<inlineCode parentName="p">{`UnderlineNav`}</inlineCode>{`.`}</p>
    <h2>{`Examples`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<UnderlineNav aria-label="Main">
  <UnderlineNav.Link href="#home" selected>
    Home
  </UnderlineNav.Link>
  <UnderlineNav.Link href="#documentation">Documentation</UnderlineNav.Link>
  <UnderlineNav.Link href="#support">Support</UnderlineNav.Link>
</UnderlineNav>
`}</code></pre>
    <h2>{`Props`}</h2>
    <ComponentProps data={data} mdxType="ComponentProps" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      